import { cn } from '@/utils/cn';

interface LoadingSpinnerProps {
  size?:  'sm' | 'md' | 'lg' | 'xl';
  color?: 'current' | 'white' | 'primary';
  className?: string;
}

const sizeClasses = {
  sm: 'h-3.5 w-3.5 border-[1.5px]',
  md: 'h-5   w-5   border-2',
  lg: 'h-7   w-7   border-2',
  xl: 'h-10  w-10  border-[3px]',
};

const colorClasses = {
  current: 'border-current border-t-transparent',
  white:   'border-white border-t-transparent',
  primary: 'border-primary-600 border-t-transparent',
};

export default function LoadingSpinner({
  size = 'md',
  color = 'primary',
  className,
}: LoadingSpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block rounded-full animate-spin',
        sizeClasses[size],
        colorClasses[color],
        className
      )}
    />
  );
}

/** Full-page loading screen */
export function FullPageSpinner({ message = 'Loading…' }: { message?: string }) {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-surface-50">
      <LoadingSpinner size="xl" color="primary" />
      <p className="text-sm text-surface-500">{message}</p>
    </div>
  );
}
